<template>
  <div>
    <img class="banner-img" :src="this.$route.query.targetUrl" alt=""/>
  </div>
</template>

<script>
export default {
  name: 'index'
}
</script>

<style scoped>
.banner-img {
  height: 100%;
  width: 100%
}
</style>
